export default {"src":"/_next/static/image/src/components/PlansCarousel/checkmark.d2f00c8fa8919e512d084adf8b19b642.svg","height":25,"width":27};